import { getAllDressCodes } from '../api';
import { sortArrayByFieldAsc } from '../helpers/general';
import { dispatchErrorAction } from './index';
import { GET_ALL_DRESS_CODES_SUCCESS } from './actionTypes';

export function getAllDressCodesAction () {
  return dispatch => getAllDressCodes()
    .then(data => {
      const sortedDressCodeList = sortArrayByFieldAsc(data.data, 'description_en');
      dispatch({ type: GET_ALL_DRESS_CODES_SUCCESS, dressCodes: sortedDressCodeList });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}



// WEBPACK FOOTER //
// ./src/actions/dressCode.js